<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
  *{
    /*overflow-x: hidden;*/
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
  }
  #app{
    background-color: #2C2E34;
  }
  @font-face {
    font-family: "Avenir";
    src: url('http://activity.elab-plus.com/elabGuanWang/Avenir.ttf');
  }
  @font-face {
    font-family: "DINCondensed-Bold";
    src: url('http://activity.elab-plus.com/elabGuanWang/DINCondensedBold.ttf');
  }
  @font-face {
    font-family: "ChinaThinGold";
    src: url('http://activity.elab-plus.com/elabGuanWang/ChinaThinGold.ttf');
  }
  @font-face {
    font-family: "DINCond";
    src: url('http://yun-image.elab-plus.com/font/DINCond-Bold.otf');
  }
  @font-face {
    font-family: "AritaHeiti";
    src: url('https://dm.static.elab-plus.com/elabGuanWang/font/Arita-Heiti.ttf');
  }
  @font-face {
    font-family: "AritaHeiti-Light";
    src: url('https://dm.static.elab-plus.com/elabGuanWang/font/AritaHeiti-Light.ttf');
  }

  @font-face {
    font-family: "AritaHeiti-Bold";
    src: url('https://dm.static.elab-plus.com/elabGuanWang/font/AritaHeiti-Bold.ttf');
  }

  @font-face {
    font-family: "DINCond-Light";
    src: url('http://activity.elab-plus.com/elabGuanWang/DINCond-Light.otf');
  }
  .el-timeline-item:first-of-type .el-timeline-item__node{
    margin-top: 190px;
  }
  .el-timeline-item:nth-child(3) .el-timeline-item__node{
    margin-top: 10px;
  }
  .el-timeline-item:nth-child(4) .el-timeline-item__node{
    width: 0px;
  }
  .el-timeline-item:nth-child(7) .el-timeline-item__node{
    width: 0px;
  }
  .el-timeline-item:nth-child(10) .el-timeline-item__node{
    width: 0px;
  }
  .el-timeline-item:nth-last-child(0) .el-timeline-item__node{
    width: 0px;
  }
  .el-timeline-item:nth-last-child(1) .el-timeline-item__node{
    width: 0px;
  }
  .el-timeline-item:nth-last-child(2) .el-timeline-item__node{
    width: 0px;
  }
  .el-timeline-item:nth-last-child(3) .el-timeline-item__node{
    width: 0px;
  }
  .el-carousel__container{
    overflow: hidden;
  }
  .el-carousel__item{
    overflow: hidden;
  }
  .divideForIphone{
    height: 1px;
    position: relative;
  }

  @media (max-width: 767px){
    .el-carousel__indicator{
      padding: 12px 14px;
    }
    .el-timeline-item__node{
      width: 16px;
      height: 16px;
      left: -3px;
    }
    .el-timeline-item__tail {
      position: absolute;
      left: 4px;
      height: 100%;
      border-left: 2px solid #B0B0B0
    }
  }

  @media (min-width: 768px){
    .el-timeline-item__node{
      width: 21px;
      height: 21px;
      left: -5px;
    }
    .el-timeline-item__tail {
      position: absolute;
      left: 4px;
      height: 100%;
      border-left: 2px solid #B0B0B0
    }
  }

  @media (min-width: 992px){
    .el-timeline-item__node{
      width: 21px;
      height: 21px;
      left: -5px;
    }
    .el-timeline-item__tail {
      position: absolute;
      left: 4px;
      height: 100%;
      border-left: 2px solid #B0B0B0
    }
  }

  @media (min-width: 1200px){
    .el-timeline-item__node{
      width: 21px;
      height: 21px;
      left: -5px;
    }
    .el-timeline-item__tail {
      position: absolute;
      left: 4px;
      height: 100%;
      border-left: 2px solid #B0B0B0
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue